import { useState } from "react";
import LoginForm from "./components/LoginForm";

function App() {
  const [tab, setTab] = useState("kunde");

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="flex justify-center space-x-4 mb-4">
        <button onClick={() => setTab("kunde")} className="px-4 py-2 bg-teal-600 text-white rounded">
          Kunden Login
        </button>
        <button onClick={() => setTab("admin")} className="px-4 py-2 bg-gray-600 text-white rounded">
          Admin Login
        </button>
      </div>
      <LoginForm role={tab} />
    </div>
  );
}

export default App;
